import React, { HtmlHTMLAttributes, useMemo, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import * as locales from "@mui/material/locale";
import { AuthProvider } from "./auth";

type SupportedLocales = keyof typeof locales;

interface IAppProvider extends HtmlHTMLAttributes<HTMLElement> {}

const AppProvider: React.FC<IAppProvider> = ({ children }) => {
  const [locale] = useState<SupportedLocales>("ptBR");

  document.documentElement.style.setProperty("--primary-color", "#000");
  document.documentElement.style.setProperty("--secondary-color", "#fff");
  document.documentElement.style.setProperty("--tertiary-color", "#666");

  const themeWithLocale = useMemo(
    () =>
      createTheme(
        {
          typography: {
            fontFamily: '"Roboto", sans-serif',
          },
          palette: {
            primary: {
              light: "#000",
              main: "#000",
              dark: "#000",
              contrastText: "#fff",
            },
          },
          components: {
            MuiButton: {
              styleOverrides: {
                root: {
                  borderRadius: "4px",
                },
              },
            },
          },
        },
        locales[locale],
      ),
    [locale],
  );

  return (
    <ThemeProvider theme={themeWithLocale}>
      <AuthProvider>{children}</AuthProvider>
    </ThemeProvider>
  );
};

export { AppProvider };
